import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class OutsideLogService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('OutsideLog');
	}

	save(tempItem: TooBig4Car.Logic.ObjectBase): Observable<TooBig4Car.Logic.OutsideLog> {
		return this.myBaseService.save(tempItem, this.url);
	}

	get(id: System.Guid): Observable<TooBig4Car.Logic.DeliveryZone> {
		return this.myBaseService.get(id, this.url);
	}
	search(searchObj: TooBig4Car.Logic.DateSearchVM): Observable<TooBig4Car.Logic.OutsideLog[]> {
		return this.myBaseService.post(searchObj, this.url + '/Search', false);
	}
}

